import { Box, Button, Grid, Tabs, Tab, Typography, Divider } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TradingViewWidget from 'react-tradingview-widget';
import { CustomChart } from '../../../frontend/components';
import { quarterlyReviewAction, quarterlySegmentAction, vdrData20YearsAction, vdrData20YearsQuarterlyAction, vdrPeerToPeerAction } from '../../../redux/actions/VdrAction';
import PropTypes from 'prop-types';
import { historicalTrendChooseField } from '../../../constants/defaultArray';
import HistoricalTrendChooseField from './HistoricalTrendChooseField';
import PeerToPeerTrendChooseField from './PeerToPeerTrendChooseField';
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';
import ForensicComponent from '../../../frontend/components/ForensicComponent';
import QuarterlyReview from './QuarterlyReview';
import QuarterlySegment from './QuarterlySegment';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const FinancialCharts = (props) => {


    
    const { technicalData, companyId, showForensic, showDownload, setOpenForm, toggleDrawer, setParentGroup } = props;
    const myRef = useRef();
    const divRef = useRef();
    const HistoricalRef = useRef();
    const PeerToPeerRef = useRef();

    const dispatch = useDispatch();

    const { data: quarterlyData, loading: quarterlyLoading } = useSelector(state => state.vdrData20YearsQuarterlyReducer)
    const { data, loading } = useSelector(state => state.vdrData20YearsReducer);
    const { data: peerToPeerData, loading: peerToPeerLoading } = useSelector(state => state.vdrPeerToPeerReducer);

    const { data: quarterlyReviewData, loading: quarterlyReviewLoading } = useSelector(state => state.quarterlyReviewReducer);
    const { data: quarterlySegmentData, loading: quarterlySegmentLoading } = useSelector(state => state.quarterlySegmentReducer);


    const [ActiveQuarterlyReview, setActiveQuarterlyReview] = useState(false);

    const [ActiveQuarterlyData, setActiveQuarterlyData] = useState(null);
    const [QuarterlyAllData, setQuarterlyAllData] = useState(null);

    const [QuarterlyAllDataTotal, setQuarterlyAllDataTotal] = useState(0);

    const [HistoricalTrendData, setHistoricalTrendData] = useState(null);
    const [PeerToPeerData, setPeerToPeerData] = useState(null);

    const [PeerToPeerDataChartType, setPeerToPeerDataChartType] = useState(null);
    
    const [QuaterlySegmentType, setQuaterlySegmentType] = useState('Standalone');

    // useEffect(()=>{
    //     if(quarterlySegmentLoading){
    //         dispatch(quarterlySegmentAction({companyID:companyId}, QuaterlySegmentType));
    //     }
    // }, [quarterlySegmentLoading])

    const quarterlySelect = (quarter) => {
        setActiveQuarterlyData(quarter)
        if(quarter === "QuarterlyReview" ){
            setActiveQuarterlyReview(true);
            if(quarterlyReviewLoading){
                dispatch(quarterlyReviewAction({companyID:companyId}));
            }
        }else
        if(quarter === "QuarterlySegment" ){
            setActiveQuarterlyReview(false);
            // if(quarterlySegmentLoading){
            //     dispatch(quarterlySegmentAction({companyID:companyId}, QuaterlySegmentType));
            // }
        }else
        {
            setActiveQuarterlyReview(false);
            
            let qData = quarterlyData.Data;
            let demo0 = [];
            let title = null;
            if (qData && qData.length > 0) {
                qData = qData[0];
                Object.keys(qData).map((item, i) => {
                    var demo1 = { cat: [], value: [], title: title, typeFor: quarter, YoYQoQ: {} };
                    if (item !== '$id' && item !== '_MainHeader') {
                        var itemQData = qData[item];
                        var a = 0;
                        var a1 = 0;
                        Object.keys(itemQData).map((subItem, i1) => {
                            if (quarter === 20 || a <= quarter) {
                                if (subItem !== '$id') {
    
                                    if (subItem === '_chartName') {
                                        demo1.title = title = itemQData[subItem]?.Name;
                                    } else {
                                        if(itemQData[subItem]?.Value !== null && itemQData[subItem]?.Value !== undefined){
                                            demo1.cat = [...demo1.cat, itemQData[subItem]?.Name]
                                            demo1.value = [...demo1.value, itemQData[subItem]?.Value]
                                        }
                                    }
                                }
                            }
                            if(itemQData[subItem]?.Value !== null && itemQData[subItem]?.Value !== undefined){
                                a1++
                            }
                            a++;
                            if (subItem === '_chartName') {
                                demo1.title = title = itemQData[subItem]?.Name;
                            }
    
                            if (quarter === 5 && subItem === 'YoYQoQ') {
                                demo1.YoYQoQ = { YoY: (itemQData[subItem]?.YoY || null), QoQ: (itemQData[subItem]?.QoQ || null) }
                            }
    
    
                        });
                        setQuarterlyAllDataTotal(a1);
                        // console.log(demo1);
                        demo0[item] = demo1;
                    }
                })

                // console.log('setQuarterlyAllData >>>> ', demo0);
                setQuarterlyAllData(demo0)
            }

        }

    }


    const applyChart = (chartType) => {
        if (!chartType.length) {
            chartType = ["Market Cap (cr.)", "Net Sales (cr.)", "Cons PAT (cr.)", "Gross Profit (cr.)", "Gross Profit Margin (%)", "EBIDTA (cr.)"]
        }
        dispatch(vdrData20YearsAction([
            {
                "CompanyID": companyId,
                "userid": 1,
                "Param": chartType,
                "ChartType": "Annually"
            }
        ]))
    }





    useEffect(() => {
        if (loading) {
            dispatch(vdrData20YearsAction([
                {
                    "CompanyID": companyId,
                    "userid": 1,
                    "Param": ["Market Cap (cr.)", "Net Sales (cr.)", "Cons PAT (cr.)", "Gross Profit (cr.)", "Gross Profit Margin (%)", "EBIDTA (cr.)"],
                    "ChartType": "Annually"
                }
            ]))
        }
        if (!loading) {
            let qData = data.Data;
            let demo0 = [];
            let title = null;
            if (qData && qData.length > 0) {
                qData = qData[0];
                Object.keys(qData).map((item, i) => {
                    var demo1 = { cat: [], value: [], title: title, typeFor: 20, CAGR: "" };
                    if (item !== '$id' && item !== '_MainHeader') {
                        var itemQData = qData[item];
                        var a = 0;
                        Object.keys(itemQData).map((subItem, i1) => {

                            if (subItem !== '$id') {
                                if (subItem === '_chartName') {
                                    demo1.title = title = itemQData[subItem]?.Name;
                                    if (itemQData[subItem]?.CAGR) {
                                        demo1.CAGR = itemQData[subItem]?.CAGR;
                                    }
                                } else {
                                    if (itemQData[subItem]?.Value !== null && itemQData[subItem]?.Value !== undefined) {
                                        demo1.cat = [...demo1.cat, itemQData[subItem]?.Name]
                                        // var value1 = itemQData[subItem]?.Value ? itemQData[subItem]?.Value.toFixed() : itemQData[subItem]?.Value;
                                        var value1 = parseFloat(itemQData[subItem]?.Value).toFixed(0);
                                        
                                        demo1.value = [...demo1.value, value1]
                                    }
                                }
                            }
                        });
                        demo0[item] = demo1;
                    }
                })
                setHistoricalTrendData(demo0)
            }
        }
    }, [dispatch, loading])



    const exportImageData = async (current_ref) => {
        // console.log('exportImageData')
        await htmlToImage.toJpeg(current_ref)
        .then(function (dataUrl) {
          // console.log(dataUrl);
          download(dataUrl, 'my-node.png');
        });
      }



    const applyAction = (chartType, companies) => {
        let companies1 = companies;
          var companies0 = companies1.unshift(companyId);
        // console.log(companies1);
        dispatch(vdrPeerToPeerAction([{
            "CompanyId": companyId,
            "userid": 1,
            "param": chartType,
            "CompanyParam": companies1
        }]))
        setPeerToPeerDataChartType(chartType);

        // dispatch(vdrData20YearsAction([
        //     {
        //         "CompanyID": companyId,
        //         "userid": 1,
        //         "Param": chartType,
        //         "ChartType": "Annually"
        //     }
        // ]))
    }


    useEffect(() => {
        if (peerToPeerLoading) {
            // dispatch(vdrPeerToPeerAction([{ "CompanyId": 132805, "userid": "22", "param": "PE (x)", "CompanyParam": ["132805", "105412", "106076", "132670", "101425", "124226"] }]))
        }
        if (!peerToPeerLoading) {
            let qData = peerToPeerData.Data;
            let demo0 = [];
            let title = null;
            if (qData && qData.length > 0) {
                qData = qData[0];
                Object.keys(qData).map((item, i) => {
                    var demo1 = { cat: [], value: [], title: title, typeFor: 20 };
                    if (item !== '$id' && item !== '_MainHeader') {
                        var itemQData = qData[item];
                        var a = 0;
                        Object.keys(itemQData).map((subItem, i1) => {

                            if (subItem !== '$id') {
                                if (subItem === '_chartName') {
                                    demo1.title = title = itemQData[subItem]?.Name;
                                } else {
                                    // if (itemQData[subItem]?.Value !== null) {
                                        demo1.cat = [...demo1.cat, itemQData[subItem]?.Name]
                                        var value1 = itemQData[subItem]?.Value?parseFloat(itemQData[subItem]?.Value).toFixed(0):null;
                                        demo1.value = [...demo1.value, value1]
                                    // }
                                }
                            }
                        });
                        demo0[item] = demo1;
                    }
                })
                setPeerToPeerData(demo0)
            }
        }
    }, [dispatch, peerToPeerLoading])

    useEffect(() => {
        if (quarterlyLoading) {
            dispatch(vdrData20YearsQuarterlyAction([
                {
                    "CompanyID": companyId,
                    "userid": 1,
                    "Param": [],
                    "ChartType": "Quarterly"
                }
            ]))
        }
        if (!quarterlyLoading) {
            quarterlySelect(5);
        }
    }, [dispatch, quarterlyLoading])



    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>

            <Box sx={{ width: '100%' }} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tabs variant='scrollable' allowScrollButtonsMobile
                                    scrollButtons="auto" value={value} onChange={handleChange} aria-label="basic tabs example">
                        <Tab sx={{
                            fontSize: '0.7rem'
                        }} label="Interim Results" {...a11yProps(0)} />
                        <Tab sx={{
                            fontSize: '0.75rem'
                        }} label="Historical Annual Trend" {...a11yProps(1)} />
                        <Tab sx={{
                            fontSize: '0.75rem'
                        }} label="Peer Analysis" {...a11yProps(2)} />
                        {
                            showForensic && (
                                <Tab sx={{
                                    fontSize: '0.75rem'
                                }} label="Forensic Model" {...a11yProps(3)} />
                            )
                        }
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Box sx={{
                        marginTop: 0
                    }}>
                    
                        <Box>
                            {
                                QuarterlyAllDataTotal >= 5
                                ?
                                <Button className={`${ActiveQuarterlyData === 5 ? 'btn_active' : null}`} onClick={() => quarterlySelect(5)} variant="outlined" size="small" sx={{ margin: '0.2rem' }} type="button">5 Quarterly</Button>
                                :
                                null
                            }
                            {
                                QuarterlyAllDataTotal > 5
                                ?
                                <Button className={`${ActiveQuarterlyData === 10 ? 'btn_active' : null}`} onClick={() => quarterlySelect(10)} variant="outlined" size="small" sx={{ margin: '0.2rem' }} type="button">10 Quarterly</Button>
                                :
                                null
                            }
                            {
                                QuarterlyAllDataTotal > 10
                                ?
                                <Button className={`${ActiveQuarterlyData === 20 ? 'btn_active' : null}`} onClick={() => quarterlySelect(20)} variant="outlined" size="small" sx={{ margin: '0.2rem' }} type="button">20 Quarterly</Button>
                                :
                                null
                            }
                            
                            <Button className={`${ActiveQuarterlyReview === true ? 'btn_active' : null}`} onClick={() => quarterlySelect('QuarterlyReview')} variant="outlined" size="small" sx={{ margin: '0.2rem' }} type="button">Quarterly Review</Button>
                            
                            <Button className={`${ActiveQuarterlyData === "QuarterlySegment" ? 'btn_active' : null}`} onClick={() => quarterlySelect('QuarterlySegment')} variant="outlined" size="small" sx={{ margin: '0.2rem' }} type="button">Quarterly Segment</Button>
                            
                        </Box>
                        <Box sx={{
                            marginTop: 3
                        }}>
                        {
                            showDownload && (
                                <Grid item xs={12} sx={{ textAlign:'right' }}>
                                    <Button onClick={()=>exportImageData(divRef.current)} type="button" size="small" sx={{ fontSize:10 }} variant="outlined" >Download Image</Button>
                                </Grid>

                            )
                        }
                                
                            <Grid container rowSpacing={0} sx={{ backgroundColor:'#fff' }} columnSpacing={{ xs: 1 }} ref={divRef}>
                            
                            {
                                ActiveQuarterlyData === "QuarterlySegment" ?
                                <>
                                    <Grid item xs={12} >
                                        <QuarterlySegment companyId={companyId} QuaterlySegmentType={QuaterlySegmentType} setQuaterlySegmentType={setQuaterlySegmentType} />
                                    </Grid>
                                </>
                                :
                                ActiveQuarterlyReview ?
                                <>
                                    <Grid item xs={12} >
                                        <QuarterlyReview />
                                    </Grid>
                                </>
                                :
                                <>
                                    {
                                        QuarterlyAllData &&
                                        Object.keys(QuarterlyAllData).map((item) => (
                                            <Grid item xs={12} sm={6} md={2} >
                                                <div>
                                                    <CustomChart chartData={QuarterlyAllData && QuarterlyAllData[item]} chartCategory={[]} />
                                                </div>
                                            </Grid>
                                        ))
                                    }
                                </>

                            }
                            

                               
                            </Grid>
                        </Box>
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Box sx={{
                        marginTop: 1
                    }}>
                        {
                            showDownload && (

                        <Grid item xs={12} sx={{ textAlign:'right' }}>
                            <Button onClick={()=>exportImageData(HistoricalRef.current)} type="button" size="small" sx={{ fontSize:10 }} variant="outlined" >Download Image</Button>
                        </Grid>
                            )
                        }
                        <HistoricalTrendChooseField applyChart={applyChart} />

                        <Grid container rowSpacing={0} columnSpacing={{ xs: 1 }} ref={HistoricalRef} sx={{ backgroundColor:'#fff' }} >
                            {
                                HistoricalTrendData &&
                                Object.keys(HistoricalTrendData).map((item) => (
                                    <Grid item xs={12} sm={6} md={2} >
                                        <div>
                                            <CustomChart chartData={HistoricalTrendData[item]} chartCategory={[]} />
                                        </div>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Box sx={{
                        marginTop: 1
                    }}>
                        {/* <Typography variant="h6">To be Updated</Typography> */}
                        {
                            showDownload && (

                        <Grid item xs={12} sx={{ textAlign:'right' }}>
                            <Button onClick={()=>exportImageData(PeerToPeerRef.current)} type="button" size="small" sx={{ fontSize:10 }} variant="outlined" >Download Image</Button>
                        </Grid>
                            )
                        }

                        <PeerToPeerTrendChooseField applyAction={applyAction} />
                        {
                            PeerToPeerDataChartType ?
                                <>
                                    <Grid item xs={12}
                                        sx={{ margin: "0.5rem 0" }}
                                    >
                                        <Typography
                                            variant='h6'
                                            textAlign={'center'}
                                        >
                                            Selected Chart Type: <strong>{PeerToPeerDataChartType}</strong>
                                            <Divider />
                                        </Typography>
                                    </Grid>
                                    
                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 1 }} ref={PeerToPeerRef} sx={{ backgroundColor:'#fff' }} >
                                        {
                                            PeerToPeerData &&
                                            Object.keys(PeerToPeerData).map((item) => (
                                                <Grid item xs={12} sm={6} md={2} >
                                                    <div>
                                                        <CustomChart chartData={PeerToPeerData && PeerToPeerData[item]} chartCategory={[]} />
                                                    </div>
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </>
                                :
                                null
                        }

                    </Box>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ForensicComponent companyId={companyId} setParentGroup={setParentGroup} setOpenForm={setOpenForm} toggleDrawer={toggleDrawer} />
                </TabPanel>
            </Box>


        </>
    )
}

export default FinancialCharts